import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

export const TextInput = ({
    caption,
    onChange,
    type,
    value,
    placeholder,
    isPassword,
    toggleType
}) => {
    return (
        <div className={classNames('input-container')}>
            <div className="input-caption">{caption}</div>
            <input
                className={classNames("form-input")}
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e)}
            />
            {isPassword && (
                <FontAwesomeIcon 
                    icon={type==='text' ? faEyeSlash : faEye}
                    onClick={toggleType}
                    className={classNames("input-caption",'pass-icon')} 
                />
            )}
        </div>
    );
}